import React from 'react';
import { Tag, Tooltip } from 'antd';
import SmsPlaceholders from '../Models/SmsPlaceholder';

interface Props {
  onInsert: (code: string) => void;
  disabled?: boolean;
}

const grouped = SmsPlaceholders.reduce<Record<string, typeof SmsPlaceholders>>((acc, p) => {
  acc[p.category] = acc[p.category] ? [...acc[p.category], p] : [p];
  return acc;
}, {});

const SmsPlaceholderLegend: React.FC<Props> = ({ onInsert, disabled }) => (
  <div style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 12, background: '#fafafa' }}>
    <div style={{ fontWeight: 600, marginBottom: 4, color: '#7c3aed' }}>Légende des codes disponibles</div>
    <div style={{ fontSize: 12, color: '#888', marginBottom: 10 }}>
      Cliquez sur un code pour l'insérer dans le message à la position du curseur.
    </div>
    {Object.entries(grouped).map(([category, items]) => (
      <div key={category} style={{ marginBottom: 10 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>{category}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {items.map((p) => (
            <Tooltip key={p.code} title={p.label}>
              <Tag
                color="purple"
                style={{ cursor: disabled ? 'not-allowed' : 'pointer', fontWeight: 700, opacity: disabled ? 0.5 : 1 }}
                onClick={() => !disabled && onInsert(p.code)}
              >
                {p.code}
              </Tag>
            </Tooltip>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default SmsPlaceholderLegend;